import React from "react";
import { HiMagnifyingGlass } from "react-icons/hi2";
import {
  fetchAdminContacts,
  useAddAdminContact,
  useAdminContacts,
  useDeleteAdminContact,
} from "../../../api/admin-contact/use-admin-contact";
import Button from "../../../components/ui/Button/Button";
import { Dropdown } from "../../../components/ui/Dropdown/Dropdown";
import AdminContactTable from "./AdminContactTable";
import Modal from "../../../components/ui/Modal/Modal";
import { useEffect } from "react";

const options = [
  { id: "name", name: "성명" },
  { id: "affiliation", name: "소속" },
  { id: "phone", name: "휴대전화 번호" },
];

const AdminContact = () => {
  const [searchBy, setSearchBy] = React.useState("name");
  const [searchValue, setSearchValue] = React.useState("");
  const { data: contactList } = useAdminContacts(false, searchBy, searchValue);
  const [contactListData, setContactListData] = React.useState(
    contactList?.data
  );
  const [isAddMode, setIsAddMode] = React.useState(false);
  const [inputContact, setInputContact] = React.useState({});
  const [selectedContact, setSelectedContact] = React.useState([]);
  const { mutate: addAdminContact } = useAddAdminContact();
  const { mutate: deleteAdminContact } = useDeleteAdminContact();
  const [notFoundPopup, setNotFoundPopup] = React.useState(false);

  const onAddContact = () => {
    setIsAddMode(true);
  };

  const onChangeInputContact = (e, id) => {
    const value = e.target.value;
    setInputContact({ ...inputContact, [id]: value });
  };

  useEffect(() => {
    setContactListData(contactList?.data);
  }, [contactList]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addAdminContact(inputContact);
    setInputContact({
      name: "",
      affiliation: "",
      phone: "",
    });
    setIsAddMode(false);
  };

  const handleSelectContact = (id) => {
    const index = selectedContact.indexOf(id);

    if (!selectedContact.includes(id)) {
      setSelectedContact([...selectedContact, id]);
    }
    if (index > -1) {
      selectedContact.splice(index, 1);
      setSelectedContact([...selectedContact]);
    }
  };

  const onDeleteContact = async () => {
    await deleteAdminContact({
      ids: selectedContact,
    });
    setSelectedContact([]);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const res = await fetchAdminContacts(false, searchBy, searchValue);
    setContactListData(res?.data);
    if (res?.data?.length === 0) {
      setNotFoundPopup(true);
    }
  };

  const handleResetSearch = async () => {
    const res = await fetchAdminContacts(false);
    setContactListData(res?.data);
    setSearchValue("");
  };

  return (
    <div className="px-6">
      <div className="flex justify-between">
        <Dropdown
          width="w-32"
          options={options}
          height="h-10"
          positionDropdown={`top-12`}
          placeholder="성명"
          textColor="text-black px-4"
          onClickItem={(id) => setSearchBy(id)}
        />
        <form className="flex" onSubmit={handleSearch}>
          <input
            type="search"
            className={`w-[230px] text-black border-l border-t border-b border-button-grey rounded-l-[4px] p-2 focus:outline-0 ${
              isAddMode
                ? "text-white bg-[#dddddd] border border-[#cccccc] cursor-not-allowed placeholder:text-white"
                : ""
            }`}
            placeholder="수신할 관리자 정보 입력 후, 검색"
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
            disabled={isAddMode}
          />
          <button
            type={isAddMode ? "button" : "submit"}
            className="cursor-pointer flex items-center bg-[#19459f] px-4 py-2 border-r border-[#19459f] rounded-r-[4px]"
          >
            <HiMagnifyingGlass className="text-white text-[18px] m-auto" />
          </button>
        </form>
        <Button
          text="검색결과 초기화"
          isDisabled={isAddMode}
          margin="mr-0"
          disabledTextColor="text-white"
          borderColor="border-[#cccccc] border"
          onClick={handleResetSearch}
        />
      </div>
      <div className="mt-3">
        <AdminContactTable
          selectedContact={selectedContact}
          handleSelectContact={handleSelectContact}
          contactList={contactListData}
        />
        <div className="flex mb-2.5 mt-3 justify-end gap-0.5">
          <Modal
            onSubmit={onDeleteContact}
            maxWidth="max-w-[28rem]"
            description={
              <div>
                <p>
                  해당 항목을 삭제하시겠습니까?{" "}
                  <span className="w-full text-[#E80000]">
                    SMS 발송 대상으로 등록된 관리자를 선택
                    <br />
                    삭제 한 경우, 연동되어 발송 대상자에서 삭제 처리됩니다.
                  </span>
                </p>
              </div>
            }
          >
            <Button
              isDisabled={isAddMode || selectedContact.length === 0}
              width="w-[6rem]"
              disabledTextColor="text-white"
              text="선택삭제"
              borderColor="border-[#cccccc] border"
            />
          </Modal>

          <Button
            onClick={onAddContact}
            isDisabled={isAddMode}
            disabledTextColor="text-white"
            text="연락처 추가"
            width="w-[6rem]"
            primary
            margin="mr-0"
          />
        </div>
        <div>
          {isAddMode ? (
            <form onSubmit={handleSubmit}>
              <h3 className="text-[14px] font-bold mb-3">연락처 추가</h3>
              <table className="w-full text-center mb-3">
                <thead>
                  <tr className="border border-[#dddddd]" key={0}>
                    <th className="font-normal p-2 bg-[#f2f2f4] border border-[#dddddd]">
                      소속
                    </th>
                    <th className="font-normal p-2 bg-[#f2f2f4] border border-[#dddddd]">
                      성명
                    </th>
                    <th className="font-normal p-2 bg-[#f2f2f4] border border-[#dddddd]">
                      휴대전화 번호
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td className="p-2 border border-[#dddddd]">
                      <input
                        type="text"
                        className="text-center focus:outline-none"
                        onChange={(e) => onChangeInputContact(e, "name")}
                        placeholder="소속명 입력"
                        value={inputContact?.name}
                      />
                    </td>
                    <td className="p-2 border border-[#dddddd]">
                      <input
                        type="text"
                        className="text-center focus:outline-none"
                        onChange={(e) => onChangeInputContact(e, "affiliation")}
                        placeholder="성명 입력"
                        value={inputContact?.affiliation}
                      />
                    </td>
                    <td className="py-2 border border-[#dddddd]">
                      <input
                        type="text"
                        className="text-center focus:outline-none w-[10rem] "
                        onChange={(e) => onChangeInputContact(e, "phone")}
                        placeholder="휴대전화 번호 입력 (숫자만)"
                        value={inputContact?.phone}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <Button
                type="submit"
                primary
                isDisabled={
                  !inputContact.name ||
                  !inputContact.affiliation ||
                  !inputContact.phone
                }
                text="등록완료"
                width="w-full"
                className="h-10"
              />
            </form>
          ) : (
            <div className="mt-4 text-[#e80000]">
              ※ SMS 발송 대상으로 등록된 관리자를 선택삭제 한 경우, 연동되어
              발송 대상 자에서 삭제처리됩니다.
            </div>
          )}
        </div>
      </div>

      {notFoundPopup && (
        <Modal
          isOpenFromOutside={notFoundPopup}
          setIsOpenFromOutside={setNotFoundPopup}
          description="검색 결과가 없습니다."
          hasCancel={false}
        />
      )}
    </div>
  );
};

export default AdminContact;
